import React, { createContext, useContext, useEffect, useState } from "react";
import { socket } from "../api";
import { parseJWT } from "../utils/jwtUtils";

const BalanceContext = createContext();

export const BalanceProvider = ({ children }) => {
  const [balance, setBalance] = useState(0);

  const tokenData = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const userInfo = parseJWT(tokenData?.token);

  // helper function (IMPORTANT)
  const updateBalance = (newBalance) => {
    setBalance(newBalance);
  };

  useEffect(() => {
    if (!userInfo?.phone) return;

    socket.emit("getBalance", { phone: userInfo.phone });

    const handleBalance = (data) => {
      if (data?.success) {
        setBalance(data.balance);
      }
    };

    socket.on("balanceResponse", handleBalance);

    return () => {
      socket.off("balanceResponse", handleBalance);
    };
  }, [userInfo?.phone]);

  return (
    <BalanceContext.Provider value={{ balance, setBalance, updateBalance }}>
      {children}
    </BalanceContext.Provider>
  );
};

export const useBalance = () => useContext(BalanceContext);
